import { useRouteMatch } from 'react-router-dom';

import RouterPaths from '../../common/RouterPaths';

/**
 * Returns true when the current location matches the read-only content view
 * route (`/view/:contentId`). Use this to distinguish the view page from the
 * edit page in components (e.g. the action panel) that render on both.
 */
export function useIsViewRoute(): boolean {
  // When the location matches the view route, then we are in read-only mode.
  return useRouteMatch({ path: RouterPaths.CONTENT_VIEW, exact: true }) !== null;
}
